// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const itin: CountryValidator<"US"> = createValidator(
  "us.itin",
  169,
);

export default itin;
export const compact = itin.compact;
export const format = itin.format;
export const validate = itin.validate;
export const generate = (): string =>
  itin.generate?.() ??
  (() => {
    throw new Error(
      "Validator us.itin cannot generate values",
    );
  })();
